export default ({cookieName, cookieValue, expireDate}) => {
    document.cookie = cookieName + "=" + cookieValue + "; expires=" + expireDate;
};